document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', event => {
    if (event.target.matches('.use-products .product_block, .use-products .product_block *')) {
      const targetBlock = event.target.closest('.product_block');
      handleElementChange(targetBlock);
    }
  });

  document.body.addEventListener('mouseenter', event => {
    if (event.target.matches('.use-products .product_block, .use-products .product_block *')) {
      const targetBlock = event.target.closest('.product_block');
      handleElementChange(targetBlock);
    }
  }, true);

  function handleElementChange(ele) {
    const hoverImgId = ele.dataset.hoverImgId;
    const gifImgId = ele.dataset.gifImgId;

    document.querySelectorAll('.product_block').forEach(block => {
      block.classList.remove('block-selected');
    });

    ele.classList.add('block-selected');

    document.querySelectorAll('.use-products .gif_image, .use-products .hovered_image, .use-products .hovered_bubble')
      .forEach(img => img.classList.add('no-disp'));

    if (document.querySelector(`.use-products #${gifImgId}`)) {
      document.querySelector(`.use-products #${gifImgId}`).classList.remove('no-disp');
    }
    if (document.querySelector(`.use-products #${hoverImgId}`)) {
      document.querySelector(`.use-products #${hoverImgId}`).classList.remove('no-disp');
    }
  }
});


